'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/images/images.controller'
],function(angular,SinglePageImagesCtrl){
    var app=angular.module('app.seospider.exam.analysis.detail.images', []);
    app.controller('SinglePageImagesCtrl',SinglePageImagesCtrl);
    return app;
});